export default __webpack_public_path__ + "static/media/Family.1aa8953e.jpg";